import type { FunctionComponent } from "react";

import { HeaderArticleSpeechContainerElementID } from "scmp-app/components/header/consts";
import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";

import { Container } from "./styles";

export type HeaderFeaturesArticleSpeechProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesArticleSpeech: FunctionComponent<HeaderFeaturesArticleSpeechProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => (
  <Container
    $shouldSwap={shouldSwap}
    $showIn={showIn}
    $showOnSwap={showOnSwap}
    id={HeaderArticleSpeechContainerElementID}
  />
);

HeaderFeaturesArticleSpeech.displayName = "HeaderFeaturesArticleSpeech";
